// @flow
import { useContext } from 'react';
import { RATE_CARD_ID_BACKEND_NAME } from '@src/constants';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateRateCardId = () => {
  const estimate = useContext(EstimateContext);
  const rateCardId = estimate?.inputs?.[RATE_CARD_ID_BACKEND_NAME] ?? null;

  if (rateCardId == null) {
    throw new Error('Rate Card ID not found in Estimate Inputs, please check!');
  }

  return rateCardId;
};
